import { JSX } from 'react'

import { IconProps } from '../../icon'

const ActivityOpen: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M8.77052 24.472C9.39347 24.7343 10.1148 24.4557 10.3771 23.8327L11.459 21.2917H16.8689L17.9508 23.8327C18.1476 24.2917 18.6066 24.5704 19.082 24.5704C19.2459 24.5704 19.4099 24.5376 19.5574 24.472C20.1803 24.2097 20.4754 23.4884 20.1967 22.8491L15.2787 11.3737C14.8853 10.4721 13.4099 10.4721 13.0164 11.3737L8.09839 22.8491C7.83609 23.472 8.11478 24.1934 8.73773 24.472H8.77052ZM14.1803 14.9802L15.8361 18.8327H12.541L14.1967 14.9802H14.1803Z'
      fill='black'
    />
    <path
      d='M24.0326 12.4615H39.1774C39.7419 12.4615 40.21 11.9036 40.21 11.2308C40.21 10.5579 39.7419 10 39.1774 10H24.0326C23.4681 10 23 10.5579 23 11.2308C23 11.9036 23.4681 12.4615 24.0326 12.4615Z'
      fill='black'
    />
    <path
      d='M39.1774 22.9231H24.0326C23.4681 22.9231 23 23.481 23 24.1538C23 24.8267 23.4681 25.3846 24.0326 25.3846H39.1774C39.7419 25.3846 40.21 24.8267 40.21 24.1538C40.21 23.481 39.7419 22.9231 39.1774 22.9231Z'
      fill='black'
    />
    <path
      d='M39.1774 16.4615H24.0326C23.4681 16.4615 23 17.0195 23 17.6923C23 18.3651 23.4681 18.9231 24.0326 18.9231H39.1774C39.7419 18.9231 40.21 18.3651 40.21 17.6923C40.21 17.0195 39.7419 16.4615 39.1774 16.4615Z'
      fill='black'
    />
    <path
      d='M39.089 34.9744H9.86679C8.81817 34.9744 8.48718 35.5323 8.48718 36.2051C8.48718 36.878 8.81817 37.4359 9.86679 37.4359H39.089C40.1377 37.4359 40.4572 36.878 40.4572 36.2051C40.4572 35.5323 40.1377 34.9744 39.089 34.9744Z'
      fill='black'
    />
    <path
      d='M39.089 28.9744H9.86679C8.81817 28.9744 8.48718 29.5323 8.48718 30.2051C8.48718 30.878 8.81817 31.4359 9.86679 31.4359H39.089C40.1377 31.4359 40.4572 30.878 40.4572 30.2051C40.4572 29.5323 40.1377 28.9744 39.089 28.9744Z'
      fill='black'
    />
  </svg>
)

export default ActivityOpen
